// extracted by mini-css-extract-plugin
module.exports = {"navBar":"styles-module--navBar--q0D5z","logo":"styles-module--logo--3mce6","nav":"styles-module--nav--K6eJk","bar":"styles-module--bar--2BVPb"};